export default __webpack_public_path__ + "static/media/AD.dd6096e0.jpg";